import React, { Component } from 'react';
import { List, OrderedMap } from 'immutable';
import debounce from 'lodash/debounce';

import css from './forms.css';

// Material UI Library
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';

class MultiText extends Component {

  constructor(props) {
    super(props);
    this.state = {
      items: OrderedMap({
        [0]: OrderedMap({
          [this.props.name]: '',
        }),
      }),
    };
  }

  handleUpdateForm = (key, e, value) => {
    const items = this.state.items.setIn([key, this.props.name], value);
    this.setState({ items: items });
    this.props.updateForm(items.toList());
  };

  addAnotherItem = () => {
    this.setState({ items: this.state.items.merge({
      [this.state.items.size]: {
        [this.props.name]: '',
      },
    }),
    });
  };

  removeItem = (key) => {
    const items = this.state.items.delete(key);
    this.setState({ items: items});
    this.props.updateForm(items.toList());
  };

  render() {
    return (
      <div>
        {this.state.items.mapEntries(([key, value]) =>
          [
            key,
            <section>
              <TextField
                key={`${this.props.name}-${key}`}
                floatingLabelText={this.props.floatingLabelText}
                className={css.textField}
                fullWidth={this.props.fullWidth}
                onChange={debounce(this.handleUpdateForm.bind(this, key), 300)}
                onBlur={this.addAnotherItem}
              />
              <IconButton
                key={`${this.props.name}-navclose-${key}`}
                onTouchTap={this.removeItem.bind(this, key)}
              >
                <NavigationClose />
              </IconButton>
            </section>,
          ]
        ).toList()}
      </div>
    );
  }
}

export default MultiText;



/** WEBPACK FOOTER **
 ** ./components/forms/MultiText.js
 **/